import cx from 'classnames';
import React from 'react';

import { Skeleton } from '../Skeleton';

interface Props {
  itemsAmount: number;
}

export const OrderTotalsSummarySkeleton = ({ itemsAmount }: Props) => {
  const rows = React.useMemo(() => Array.from({ length: itemsAmount }, () => ({})), [itemsAmount]);

  return (
    <section>
      <dl>
        {rows.map((_, index) => (
          <div
            key={`OrderTotalsSummarySkeleton-${index}`}
            className={cx('flex justify-between py-3 first:pt-0', { 'border-b border-neutral-90': index !== rows.length - 1 })}
          >
            <dt className="basis-1/2">
              <Skeleton type="text" size="large" />
            </dt>
            <dd className="basis-1/3">
              <Skeleton type="text" size="large" />
            </dd>
          </div>
        ))}
        <div className="mt-3 flex justify-between">
          <dt className="basis-1/2">
            <Skeleton type="text" size="xlarge" />
          </dt>
          <dd className="basis-1/3">
            <Skeleton type="text" size="xlarge" />
          </dd>
        </div>
      </dl>
    </section>
  );
};
